import React from 'react';

import PropTypes from 'prop-types';

// Components
import { Mui, MuiLab, TextField } from 'components';
import {
  CONTRACT_STATUS,
  ORDER_STATUS,
  RECURRENCE_STATUS,
  TUITION_STATUS,
} from 'components/common/DisplayStatus/Order';

const orderStatus = Object.keys(ORDER_STATUS).map(key => ORDER_STATUS[key]);
const contractStatus = Object.keys(CONTRACT_STATUS).map(key => CONTRACT_STATUS[key]);
const tuitionStatus = Object.keys(TUITION_STATUS).map(key => TUITION_STATUS[key]);
const recurrenceStatus = Object.keys(RECURRENCE_STATUS).map(key => RECURRENCE_STATUS[key]);

const STATUS_BY_TYPE = {
  order: orderStatus,
  contract: contractStatus,
  tuition: tuitionStatus,
  recurrence: recurrenceStatus,
};

function OrderStatusFilter(props) {
  const { type, selectedStatus, onSelect, multiple, ...otherProps } = props;
  const options = STATUS_BY_TYPE[type] || [];

  const handleStatusFilter = (event, selectedOption) =>
    onSelect(!multiple ? selectedOption?.status : selectedOption?.map(option => option.status));

  const selectedStatuses = String(selectedStatus || '').split(',');
  const selectedValue = multiple
    ? options.filter(option => selectedStatuses.includes(option?.status))
    : options.find(option => option.status === selectedStatus) || null;
  const inputLabel = type === 'recurrence' ? 'Status da recorrência' : 'Status do pedido';

  return (
    <MuiLab.Autocomplete
      multiple={multiple}
      size="small"
      options={options}
      limitTags={2}
      value={selectedValue}
      getOptionLabel={option => option?.label || ''}
      getOptionSelected={(option, value) => option?.status === value?.status}
      onChange={handleStatusFilter}
      renderOption={(option, { selected }) => (
        <>
          <Mui.ListItemIcon>
            <Mui.Icon color={selected ? 'primary' : 'secondary'}>{option?.icon}</Mui.Icon>
          </Mui.ListItemIcon>
          <Mui.ListItemText primaryTypographyProps={{ color: selected ? 'primary' : 'secondary' }}>
            {option?.label}
          </Mui.ListItemText>
        </>
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Mui.Chip
            avatar={
              <Mui.Avatar>
                <Mui.Icon fontSize="small">{option?.icon}</Mui.Icon>
              </Mui.Avatar>
            }
            label={option?.label}
            size="small"
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={inputParams => (
        <TextField {...inputParams} label={inputLabel} margin="none" size="small" />
      )}
      {...otherProps}
    />
  );
}

OrderStatusFilter.propTypes = {
  type: PropTypes.string,
  selectedStatus: PropTypes.any,
  onSelect: PropTypes.func,
  multiple: PropTypes.bool,
};

export default OrderStatusFilter;
